import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux'; 
import { authActions } from '_store'; 

export const LinkedInCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch(); 

  useEffect(() => {
    const handleLinkedInCallback = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const code = params.get('code');

        if (!code) {
          console.error("No authorization code received");
          navigate('/login', { replace: true });
          return;
        }

        console.log("Exchanging code for token...", code);

        // Make API call to exchange code for token and profile
        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/linkedin/callback?code=${code}` + code, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code }) 
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "LinkedIn authentication failed");
        }

        console.log("LinkedIn API Response:", data);

        // The response contains the full profile and token
        const { token, profile, master_password_used } = data;

        // Construct authData to match what App.jsx expects
        const authData = {
          token: token,
          user: profile,  // This contains the full profile from backend
          master_password_used: master_password_used || false
        };

        console.log("Auth Data being saved:", authData);

        // Store in localStorage
        localStorage.setItem('auth', JSON.stringify(authData));

        // ADD THIS LINE: Also store user separately
localStorage.setItem('user', JSON.stringify(profile));

        // Dispatch storage event for any listeners
        window.dispatchEvent(new Event('storage'));

        // Update Redux State
        dispatch(authActions.setAuth(authData));

        // Small delay to ensure Redux state is updated
        setTimeout(() => {
          navigate('/home', { replace: true });
        }, 100);

      } catch (error) {
        console.error("LinkedIn authentication failed:", error);
        navigate('/login', { 
          replace: true, 
          state: { error: error.message || "LinkedIn login failed" } 
        });
      }
    };

    handleLinkedInCallback();
  }, [location, navigate, dispatch]);

  return (
    <div className="loader">
      <p>Authenticating with LinkedIn... Please wait.</p>
      <p>This may take a few moments.</p>
    </div>
  );
};
